"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaDisplayGroup = void 0;
/* eslint-disable import/no-cycle */
var core_ui_1 = require("@newfront-insurance/core-ui");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importDefault(require("react"));
var embedded_coverage_1 = require("./components/embedded-coverage");
var item_1 = require("./item");
var schema_display_1 = require("./schema-display");
function SchemaDisplayGroup(props) {
    var key = props.key, name = props.name, schema = props.schema, group = props.group, values = props.values;
    var inputs = group.inputs, title = group.title, stackDirection = group.stackDirection;
    if (!inputs || inputs.length === 0)
        return null;
    return (react_1.default.createElement("div", { "data-testid": "SchemaDisplayGroup-" + name + "-" + key },
        react_1.default.createElement(core_ui_1.Flexbox, { gap: 24, flexDirection: "column" },
            title && (react_1.default.createElement(core_ui_1.Flexbox, { gap: 8, flexDirection: "column" },
                react_1.default.createElement(core_ui_1.Title, { size: 17 }, title),
                react_1.default.createElement(core_ui_1.Divider, null))),
            react_1.default.createElement(core_ui_1.Flexbox, { gap: 16, flexDirection: (0, core_ui_1.stackDirectionToFlexDirection)(stackDirection || core_ui_1.StackDirectionType.HORIZONTAL) }, inputs.map(function (propertyKey) {
                var field = (schema.properties || {})[propertyKey];
                // When there is no type it means it is a hidden field.
                if (!field || !field.inputType)
                    return null;
                var inputType = field.inputType;
                if (inputType === 'nested-schema') {
                    return (react_1.default.createElement(schema_display_1.SchemaDisplay, { key: propertyKey, name: name, values: (0, get_1.default)(values, propertyKey, {}), schema: field }));
                }
                if (inputType === 'embedded-coverage') {
                    return (react_1.default.createElement(embedded_coverage_1.EmbeddedCoverageDisplay, { key: propertyKey, name: name, value: (0, get_1.default)(values, propertyKey, {}), schema: field }));
                }
                return (react_1.default.createElement(item_1.DisplayItem, { key: key + "-" + propertyKey, name: propertyKey, field: field, value: values[propertyKey] }));
            })))));
}
exports.SchemaDisplayGroup = SchemaDisplayGroup;
